// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"b9b615cd","307":"7040178b","442":"f57863bc","463":"fd70c59e","525":"fce355a4","668":"aa8a498b","675":"1043d2dd","844":"242fac5f","860":"a3a420f0","942":"991807bb"}[chunkId] + ".chunk.js";
};